import * as Html from "../util/Html.ts";
import * as hb from "../handlebars_family.ts";
export {initDom}
Html.registerWidget('widget/extra-image-opener',{initDom:initDom})

function initDom(me: HTMLElement){
  const parent = me.parentElement;
  if(!parent) return;

  // Masquer tous les éléments fw-image-extra précédents
  const extraImages = getPrevSiblings(me, '.fw-image-extra');
  extraImages.forEach(el => el.style.display = 'none');

  // Compter toutes les images
  const allImages = parent.querySelectorAll('img');
  me.textContent = hb.i18n('actions.showAllPictures', allImages);

  me.addEventListener('click', function(){
    const opened = me.dataset.fwOpened === 'true';

    if(opened){
      me.dataset.fwOpened = 'false';

      // Utiliser la nouvelle fonction fadeOut
      let remaining = extraImages.length;
      extraImages.forEach(el => {
        Html.fadeOut(el, 400)
        remaining--;
        if(remaining === 0) {
          const firstImage = getPrevSiblings(me, '.fw-image-first')[0];
          if(firstImage) firstImage.scrollIntoView();
          me.textContent = hb.i18n('actions.showAllPictures', allImages);
        }

      });

    } else {
      // Charger les images lazy
      extraImages.forEach(el => {
        el.querySelectorAll('img').forEach(img => {
          if(img.getAttribute('src') === null){
            const dataSrc = img.getAttribute('data-src');
            if(dataSrc) img.setAttribute('src', dataSrc);
          }
        });
      });

      // Utiliser la nouvelle fonction fadeIn
      let remaining = extraImages.length;
      extraImages.forEach(el => {
        Html.fadeIn(el, 400)
        remaining--;
        if(remaining === 0) {
          me.textContent = hb.i18n('actions.hideAllPictures', allImages);
        }

      });

      me.dataset.fwOpened = 'true';
    }
  });
}

// Helper pour obtenir tous les siblings précédents qui matchent un sélecteur
function getPrevSiblings(element: HTMLElement, selector: string): HTMLElement[] {
  const siblings: HTMLElement[] = [];
  let sibling = element.previousElementSibling as HTMLElement;

  while(sibling) {
    if(sibling.matches(selector)) {
      siblings.push(sibling);
    }
    sibling = sibling.previousElementSibling as HTMLElement;
  }

  return siblings;
}